













































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import PxDropdown from "@/views/components/input/formFields/PxDropdown.vue";
import {Validation, validationMixin} from "vuelidate";

import {required, maxValue, minValue} from "vuelidate/lib/validators";

@Component({
  components: {
    PxDropdown,
    PxNumberInput
  },
  mixins: [validationMixin],
  validations: {
    aadt: {
      required,
      minValue: minValue(0)
    },
    directionMultiplier: {
      required,
      minValue: minValue(0)
    },
    numDirectionalMultiplier: {
      required,
      minValue: minValue(0)
    },
    trafficGrowthRate: {
      required,
      minValue: minValue(0)
    },
    trafficYear: {
      required,
      minValue: minValue(1970),
      maxValue: maxValue(new Date(Date.now()).getFullYear())
    }
  }
})
export default class CalculateFromAadtModal extends Vue {
  @Prop() scenario!: any;

  aadt: number | null = 25000;
  directionMultiplier = 1;
  numDirectionalMultiplier = 1;
  trafficGrowthRate = 0.3;
  trafficYear = 2017;

  /*
  Lane direction
   */
  laneDirectionOptions = [
    {multValue: 1.0, text: 'One Way', value: 'One Way'},
    {multValue: 0.5, text: 'Two Way', value: 'Two Way'}
  ];

  directionMeasured = this.laneDirectionOptions[0].value;

  setDirectionMultiplier() {
    this.directionMultiplier = this.laneDirectionOptions.filter(o => o.value === this.directionMeasured)[0].multValue
  }

  /*
  Num directional lanes
   */
  numDirectionalOptions = [
    {multValue: 1.0, text: '1', value: '1'},
    {multValue: 0.9, text: '2', value: '2'},
    {multValue: 0.8, text: '3', value: '3'},
    {multValue: 0.75, text: '4+', value: '4+'}
  ];

  numDirectional = this.numDirectionalOptions[0].value;

  setDirectionalFactor() {
    this.numDirectionalMultiplier = this.numDirectionalOptions.filter(o => o.value === this.numDirectional)[0].multValue
  }

  get modifiedAadt() {
    return (this.aadt || 0) * this.directionMultiplier * this.numDirectionalMultiplier
  }

  get growthRate() {
    return Math.pow((1 + this.trafficGrowthRate / 100), this.scenario.completionYear - this.trafficYear)
  }

  get dyEsals() {
    console.log(this.growthRate);
    return 365 * this.modifiedAadt * this.growthRate
  }

  get completionYearTraffic() {
    return Number(this.dyEsals.toFixed(0))
  }

  setCompletionYearTraffic() {
    console.log("Saving traffic");
    this.scenario.initialTraffic = Number(this.completionYearTraffic.toFixed(0));
    this.$emit('save');
    this.$emit('ok');
  }
}
